module.exports = __webpack_public_path__ + "static/img/icon-insurance-11.71836f6d.png";